import { HStack, VStack, Text } from '@chakra-ui/react';
import React from 'react';
import { SelectPool } from '@app/screens/router-intent/components/SelectPool';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import { useRouterIntentState } from '@app/state/routerIntentStore';
import { TokensPair } from '@app/components/TokensPair';
import { formatUSD } from '@app/helpers/formatUSD';

export const TargetDetailsSelector = () => {
  const { targetPool } = useRouterIntentState();

  return (
    <>
      <AddLiquiditySectionTitle
        label="Choose desired pool"
        isCompleted={Boolean(targetPool)}
      />
      <HStack mt={4}>
        <SelectPool />
      </HStack>
      {targetPool && (
        <VStack
          width="100%"
          gap={4}
          mt={4}
          border="1px solid"
          borderColor="neutral.700"
          p="12px"
          borderRadius="12px"
        >
          <HStack
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text fontSize="14px" color="neutral.400">
              Composition
            </Text>
            <TokensPair
              token0Symbol={targetPool.token0.symbol}
              token1Symbol={targetPool.token1.symbol}
            />
          </HStack>
          <HStack
            width="100%"
            alignItems="center"
            justifyContent="space-between"
          >
            <Text fontSize="14px" color="neutral.400">
              TVL
            </Text>
            <Text fontSize="14px" color="neutral.100" fontWeight={500}>
              {formatUSD.format(+targetPool.totalValueLockedUSD)}
            </Text>
          </HStack>
        </VStack>
      )}
    </>
  );
};
